<template>
  <div class="pagination">
    <span class="pagination__total">共 {{ total }} 条</span>
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :total="total"
      layout="sizes, prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50]
    }
  },
  emits: ['update:currentPage', 'update:pageSize', 'size-change', 'current-change'],
  methods: {
    handleSizeChange(val) {
      this.$emit('update:pageSize', val);
      this.$emit('update:currentPage', 1);
      this.$emit('size-change', val);
    },
    handleCurrentChange(val) {
      this.$emit('update:currentPage', val);
      this.$emit('current-change', val);
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 15px 0;
}
.pagination__total {
  color: #999;
  margin-right: 10px;
}
</style>
